// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { BaseResponseDataCallAnalysisOrgOptionResponse } from '../../../types';

/**
 * 获取部门员工列表
 *
 * @export
 * @tags 智能陪练课程总览接口
 * @link [GET] /intelligentCoursePartner/homePage/organizations
 */
export function getIntelligentCoursePartnerHomePageOrganizations(): Promise<BaseResponseDataCallAnalysisOrgOptionResponse>;
export function getIntelligentCoursePartnerHomePageOrganizations(
    options: ApiOptions<never, never>
): Promise<BaseResponseDataCallAnalysisOrgOptionResponse>;
export function getIntelligentCoursePartnerHomePageOrganizations(
    options?: ApiOptions<never, never>
): Promise<BaseResponseDataCallAnalysisOrgOptionResponse> {
    return request<never, never, never>('/intelligentCoursePartner/homePage/organizations', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getIntelligentCoursePartnerHomePageOrganizations',
    });
}

export const meta = [
    {
        tags: ['智能陪练课程总览接口'],
        path: '/intelligentCoursePartner/homePage/organizations',
        method: 'get',
    },
];
